import { makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const useStyles = makeStyles((theme) => ({
  inflow_route: {
    position: 'relative',
    '& .inflowRouteLabel': {
      margin: '32px 0px 12px'
    },
    '& .MuiTypography-body2': {
      marginTop: '0 !important'
    },
    '& #selectorAnchor': {
      position: 'absolute',
      bottom: '-40px'
    },
    '& .recommendation-input': {
      marginTop: 12,
      height: 40,
      marginBottom: 48
    },
    [theme.breakpoints.down('xs')]: {
      '& .MuiGrid-container': {
        flexDirection: 'column',
        alignItems: 'flex-start',
        '& .MuiGrid-grid-xs-6': {
          paddingLeft: 8,
          maxWidth: '100%'
        }
      }
    }
  },
  selectRoot: {
    padding: '12px 12px 10px',
    '&.placeholder': {
      color: colorSet.gray700,
      fontSize: 14
    },
    '&:focus': {
      backgroundColor: 'transparent'
    }
  },
  selectMenu: {
    '& .MuiPaper-elevation8': {
      boxShadow:
        '0px 1px 5px 0px #0000001F, 0px 2px 2px 0px #00000024, 0px 3px 1px -2px #00000033'
    },
    '& .MuiMenu-paper': {
      maxHeight: '232px',
      '&::-webkit-scrollbar': {
        width: '10px'
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: '#F9F9F9',
        borderLeft: '1px solid #DEDEDE',
        boxSizing: 'content-box'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0, 0, 0, 0.54)',
        borderRadius: '5px'
      }
    }
  },
  rootMenuItem: {
    ...theme.typography.body1,
    minHeight: '36px',
    padding: '0px 16px',
    '&:first-child': {
      display: 'none'
    },
    '&.Mui-selected': {
      backgroundColor: colorSet.primary100
    },
    '&:focus': {
      backgroundColor: colorSet.primary100
    },
    '&:hover': {
      backgroundColor: colorSet.primary100
    }
  }
}));
